import { Link } from 'react-router-dom'

export function LandingHeader() {
  return (
    <header className="sticky top-0 z-20 border-b border-border/70 bg-background/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-2 px-3 py-3 sm:px-6 sm:py-3.5">
        <h1 className="flex items-center gap-2 whitespace-nowrap text-sm font-bold tracking-tight sm:gap-2.5 sm:text-lg">
          <span className="relative flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-gradient-primary shadow-sm shadow-primary/25">
            <span className="h-3.5 w-4 rounded-sm border-2 border-white border-t-0" />
          </span>
          テラファイル便
        </h1>
        <div className="flex gap-2">
          <Link
            to="/login"
            className="whitespace-nowrap rounded-lg border border-border bg-white px-2.5 py-2 text-xs font-medium transition-colors hover:bg-muted sm:px-3.5 sm:text-sm"
          >
            ログイン
          </Link>
          <Link
            to="/signup"
            className="whitespace-nowrap rounded-lg bg-gradient-primary px-2.5 py-2 text-xs font-semibold text-primary-foreground shadow-sm transition-opacity hover:opacity-90 sm:px-3.5 sm:text-sm"
          >
            <span className="sm:hidden">登録</span>
            <span className="hidden sm:inline">アカウント登録</span>
          </Link>
        </div>
      </div>
    </header>
  )
}
